import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import Loader from "../../../components/loader/Loader";
import Departments from "../../../components/leave/credits/Department";
import axiosaim from "../../../api/axiosaim";
import '../leaves.scss';
import CreditOutlet from "../../../components/leave/credits/CreditOutlet";

const Credits = () => {
    const aimtoken = sessionStorage.getItem('aimtoken') || '';
    const departmentslug = sessionStorage.getItem('departmentslug') || '';
    const uname = sessionStorage.getItem('uname'); 

    const { data: manageddepartments, isLoading: isLoadingDepartments } = useQuery({
        queryKey: ['managedAIMDepartments', uname],
        queryFn: async () => {
            const res = await axiosaim.get(`getmanageddepartments`, {
                headers: { 'X-Aim-Token': aimtoken }
            });
            return res.data;
        },
        enabled: !!uname && !!aimtoken,
        retry: 1
    });

    return (
        <div className="leave leave-credits">
            <div className="page-header">
                <div className='title'>
                    <h1>Leave Credits</h1>
                    <ul className='breadcrumbs'>
                        <li>
                            <NavLink to='/leaves/my-leave'>Leave</NavLink>
                        </li>
                        <li>
                            <span>Credits</span>
                        </li>
                    </ul>
                </div>
            </div>

            { isLoadingDepartments 
                ? (
                    <div className="columns">
                        <Loader />
                    </div>
                ) 
                : manageddepartments?.length > 1
                    ? (
                        <Departments departments={manageddepartments} loading={isLoadingDepartments} />
                    ) : (
                        <CreditOutlet departmentslug={departmentslug} />
                    )
            }

        </div>
    )
}

export default Credits;